import { HttpParams } from '@angular/common/http';
import { Pageable } from '../../../model/rest/base';
import { of, OperatorFunction, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const createPageableParams = (pageable?: Pageable): HttpParams => {
  if (!pageable) {
    return new HttpParams();
  }
  return pageable.appendParams(new HttpParams());
};

export const appendIfDefined = (
  params: HttpParams,
  key: string,
  value?: string | number | boolean | null,
): HttpParams => {
  if (value === undefined || value === null) {
    return params;
  }
  return params.append(key, String(value));
};

export const appendCollection = (
  params: HttpParams,
  key: string,
  values?: Array<string | number | boolean> | null,
): HttpParams => {
  if (!values || values.length === 0) {
    return params;
  }
  return values.reduce((acc, value) => {
    if (value === undefined || value === null) {
      return acc;
    }
    return acc.append(key, String(value));
  }, params);
};

export const serializeDateInput = (
  value?: string | Date | null,
): string | null => {
  if (value === undefined || value === null) {
    return null;
  }
  return value instanceof Date ? value.toISOString() : value;
};

export const map404ToNull = <T>(): OperatorFunction<T, T | null> =>
  catchError((error: unknown) => {
    if (error && (error as {status?: number}).status === 404) {
      return of(null);
    }
    return throwError(() => (error ?? new Error('Unknown HTTP error')));
  });
